import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import MatchDetailedVotesModal from './MatchDetailedVotesModal';
import LogInModal from 'flarum/forum/components/LogInModal';
const dayjs = window.dayjs;
export default class MatchRatingComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
    this.match = this.attrs.match || null;
    this.loading = this.match ? false : true;
    this.votes = {}; // playerId -> rating
    this.hasVoted = false; // check if current user has already voted

    if (!this.match) {
      this.loadMatch();
    } else {
      this.checkIfUserVoted();
    }
  }
  loadMatch() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches-by-discussion/".concat(this.discussion.id())
    }).then(response => {
      // Push to store. If no data, returned is null.
      if (response && response.data) {
        this.match = app.store.pushPayload(response);
      }
      this.loading = false;
      this.checkIfUserVoted();
      m.redraw();
    }).catch(e => {
      // No match for this discussion, or error
      this.loading = false;
      m.redraw();
    });
  }
  checkIfUserVoted() {
    if (!this.match || !app.session.user) return;
    const currentUserId = app.session.user.id();

    // Get votes from the relationship
    const votes = this.match.votes();
    if (!votes) return;
    const userVotes = votes.filter(vote => {
      const user = vote.user();
      return user && user.id() === currentUserId;
    });
    this.hasVoted = userVotes.length > 0;
    if (this.hasVoted) {
      userVotes.forEach(vote => {
        const player = vote.player();
        if (player) {
          this.votes[player.id()] = vote.rating();
        }
      });
    }
  }
  view() {
    if (this.loading) return m("div", null);
    if (!this.match) return m("div", null);
    const players = (this.match.players() || []).filter(p => p.attribute('isActive') !== false && p.attribute('isActive') !== 0).slice().sort((a, b) => {
      const typeA = a.entityType() || 'player';
      const typeB = b.entityType() || 'player';
      const weightA = typeA === 'player' ? 0 : typeA === 'coach' ? 1 : 2;
      const weightB = typeB === 'player' ? 0 : typeB === 'coach' ? 1 : 2;
      if (weightA !== weightB) {
        return weightA - weightB;
      }
      const posA = a.attribute('pivotPosition') !== undefined && a.attribute('pivotPosition') !== null ? a.attribute('pivotPosition') : 999;
      const posB = b.attribute('pivotPosition') !== undefined && b.attribute('pivotPosition') !== null ? b.attribute('pivotPosition') : 999;
      return posA - posB;
    });
    const matchDate = this.match.matchDate();
    const now = dayjs();
    const votingNotStarted = matchDate && now.isBefore(matchDate);
    const votingEndsAt = matchDate ? dayjs(matchDate).add(3, 'day') : null;
    const votingClosed = votingNotStarted || votingEndsAt && now.isAfter(votingEndsAt);
    if (this.match.isSuspended()) {
      return m("div", {
        className: "MatchRatingBox MatchRatingBox--suspended",
        style: "border: 1px solid rgba(245, 158, 11, 0.3); background: rgba(245, 158, 11, 0.05); border-radius: 12px; padding: 24px; text-align: center; margin-bottom: 20px;"
      }, m("div", {
        style: "font-size: 2.2rem; color: #f59e0b; margin-bottom: 10px;"
      }, m("i", {
        className: "fas fa-ban"
      })), m("h3", {
        style: "margin: 0 0 8px 0; color: #f59e0b; font-size: 1.25em; font-weight: 700;"
      }, "Partido Suspendido"), m("p", {
        style: "margin: 0 auto; color: var(--muted-color); font-size: 0.95em; max-width: 500px; line-height: 1.5;"
      }, "Las valoraciones de jugadores han quedado canceladas para este encuentro.", this.match.isSuspendedWithLineup() ? ' Las puntuaciones de 11 Aldeanos se mantienen contabilizadas en la clasificación.' : ''));
    }
    return m("div", {
      className: "MatchRatingBox"
    }, m("div", {
      className: "MatchRating-Header"
    }, m("h3", null, app.translator.trans('nagusi-match-ratings.forum.match_ratings.title'), ": ", this.match.getName())), m("div", {
      className: "MatchRating-deadline ".concat(votingClosed ? 'closed' : '')
    }, votingNotStarted ? m("span", {
      className: "closed"
    }, m("i", {
      className: "fas fa-lock"
    }), " La valoraci\xF3n comenzar\xE1 cuando empiece el partido (", dayjs(matchDate).format('LLL'), ")") : votingClosed ? m("span", {
      className: "closed"
    }, m("i", {
      className: "fas fa-lock"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.match_ratings.voting_closed')) : votingEndsAt && m("span", null, m("i", {
      className: "far fa-clock"
    }), " ", app.translator.trans('nagusi-match-ratings.forum.match_ratings.voting_ends_on', {
      date: dayjs(votingEndsAt).format('LL')
    }), m("span", {
      className: "remaining"
    }, " (", dayjs(votingEndsAt).fromNow(), ")"))), app.session.user ? m("div", {
      className: "MatchRatingBox-players"
    }, players.map(player => {
      const type = player.entityType() || 'player';
      let roleBadge = null;
      if (type === 'coach') {
        roleBadge = m("span", {
          className: "Player-Role-Badge coach"
        }, "Entrenador");
      } else if (type === 'team') {
        roleBadge = m("span", {
          className: "Player-Role-Badge team"
        }, "Equipo");
      } else {
        const pos = player.attribute('pivotPosition');
        if (pos !== null && pos !== undefined) {
          if (pos < 11) {
            roleBadge = m("span", {
              className: "Player-Role-Badge starter"
            }, "Titular");
          } else {
            roleBadge = m("span", {
              className: "Player-Role-Badge sub"
            }, "Suplente");
          }
        }
      }
      return m("div", {
        className: "MatchRating-player ".concat(type),
        key: player.id()
      }, m("span", {
        className: "MatchRating-player-info"
      }, player.photoUrl() && m("img", {
        src: player.photoUrl()
      }), m("span", {
        className: "player-name-wrapper"
      }, m("span", {
        className: "player-name"
      }, player.name()), roleBadge)), m("div", {
        className: "MatchRating-player-rating"
      }, m("input", {
        type: "range",
        min: "1",
        max: "10",
        step: "1",
        disabled: votingClosed,
        value: this.votes[player.id()] || 5,
        oninput: e => {
          this.votes[player.id()] = parseInt(e.target.value);
          m.redraw();
        }
      }), m("span", {
        className: "MatchRating-score"
      }, this.votes[player.id()] || 5)));
    }), m("div", {
      className: "MatchRatingBox-Actions"
    }, !votingClosed && m(Button, {
      className: "Button Button--primary",
      loading: this.submitting,
      onclick: this.submitVotes.bind(this)
    }, app.translator.trans(this.hasVoted ? 'nagusi-match-ratings.forum.match_ratings.resubmit_ratings' : 'nagusi-match-ratings.forum.match_ratings.submit_ratings')), m(Button, {
      className: "Button",
      onclick: () => app.modal.show(MatchDetailedVotesModal, {
        match: this.match
      })
    }, app.translator.trans('nagusi-match-ratings.forum.match_ratings.view_detailed')), m(Link, {
      className: "Button",
      href: app.route('matchRatingsStats', {
        season: this.match.seasonName().replace('/', '-')
      })
    }, app.translator.trans('nagusi-match-ratings.forum.stats.view_stats')))) : m("div", {
      className: "MatchRatingBox-GuestMessageWrapper",
      style: "text-align: center; padding: 25px 15px;"
    }, m("p", {
      style: "margin-bottom: 15px; font-weight: 500;"
    }, app.translator.trans('nagusi-match-ratings.forum.match_ratings.guest_message')), m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, m("i", {
      className: "fas fa-sign-in-alt",
      style: "margin-right: 6px;"
    }), "Acceder al foro")));
  }
  submitVotes() {
    this.submitting = true;
    const players = this.match.players() || [];
    players.forEach(p => {
      if (!this.votes[p.id()]) this.votes[p.id()] = 5;
    });
    const payload = Object.keys(this.votes).map(playerId => ({
      playerId: parseInt(playerId),
      rating: this.votes[playerId]
    }));
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/matches/".concat(this.match.id(), "/votes"),
      body: {
        data: {
          attributes: {
            votes: payload
          }
        }
      }
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('nagusi-match-ratings.forum.match_ratings.saved_message'));
      this.hasVoted = true;
      this.submitting = false;
      this.loadMatch();
    }).catch(() => {
      this.submitting = false;
      m.redraw();
    });
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/MatchRatingComponent', MatchRatingComponent);